import React, { FC } from 'react';

interface IComponentProps {
  label: React.ReactNode;
  name: string;
  checked?: boolean;
  onChange: (name: string, value: boolean) => void;
}

export const AgreementCheckbox: FC<IComponentProps> = ({ label, name, checked, onChange }) => {
  return (
    <label className="agreement-checkbox">
      <input
        id={name}
        name={name}
        type="checkbox"
        value={checked !== undefined ? `${checked}` : undefined}
        checked={checked}
        onChange={(e) => onChange(name, e.target.checked)}
      />

      <span className="agreement-checkbox__checkmark" />

      <span className="agreement-checkbox__label">{label}</span>
    </label>
  );
};
